module.exports = __webpack_public_path__ + "site-2.jpg?4516c0d3f27179defb706479a574832d";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/portfolio/site-2.jpg
 ** module id = 125
 ** module chunks = 0
 **/